// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Action bar component
 */
import React, { Component } from 'react';
import localizer from 'share/localization/Izenda.Localizer';
import Button from 'share/components/controls/Izenda.Button';

class ActionBar extends Component {
  state = {
    disabled: this.props.disabled
  };

  static propTypes = {
    onSave: React.PropTypes.func.isRequired,
    onCancel: React.PropTypes.func.isRequired,
    disabled: React.PropTypes.bool
  };

  componentDidMount() {
    this.enableComponent(this.props.disabled);
  }

  componentWillReceiveProps(nextProps) {
    this.enableComponent(nextProps.disabled);
  }

  enableComponent = isDisabled => {
    this.setState({
      disabled: isDisabled
    });
  };

  render() {
    var props = this.props;
    var state = this.state;
    var statefullChildren = React.Children.map(props.children, makeStatefull);

    return (
      <div className="izenda-ActionBarRight">
        {statefullChildren}
        <Button
          onClick={props.onSave}
          disabled={state.disabled}
          label={localizer.getText('COMMON_LABEL_SAVE')}
        />
        <Button
          className="btn-setting-default"
          onClick={props.onCancel}
          disabled={state.disabled}
          label={localizer.getText('COMMON_LABEL_CANCEL')}
          className='btn-report-default'
        />
      </div>
    );

    function makeStatefull(elem) {
      return elem && React.cloneElement(elem, { disabled: state.disabled });
    }
  }
}

export default ActionBar;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ActionBar.js